import React from 'react';
import { motion } from 'framer-motion';
import { Wind, Sparkles, RotateCw, Waves, Sun, Package, CheckCircle } from 'lucide-react';
import { PROCESS_STEPS } from '../data/content';

const iconMap = [Wind, Sparkles, RotateCw, Waves, Sun, Package, CheckCircle];

const ProcessTimeline = () => {
  return (
    <section id="proces" className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-lg text-primary-orange font-bold tracking-wider uppercase mb-3">Naš Proces</h2>
          <h3 className="text-5xl md:text-6xl font-bold text-neutral-darkNavy">7 Koraka do Savršenstva</h3>
          <p className="text-lg text-gray-500 mt-4 max-w-2xl mx-auto">
            Detaljan i pažljiv proces koji garantuje potpunu čistoću i higijenu vaših tepiha.
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-100 -translate-y-1/2 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-y-24 relative z-10">
            {PROCESS_STEPS.map((step, index) => {
              const Icon = iconMap[index];
              
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="relative group"
                >
                  {/* Step Number Badge */}
                  <div className="absolute -top-4 -right-4 w-10 h-10 bg-primary-orange text-white rounded-full flex items-center justify-center font-bold shadow-lg z-20 border-4 border-white">
                    {index + 1}
                  </div>

                  <div className={`bg-white p-6 rounded-2xl shadow-xl border border-gray-50 h-full flex flex-col items-center text-center hover:-translate-y-2 transition-transform duration-300 ${
                    index >= 3 ? 'md:mt-12' : ''
                  }`}>
                    <div className="w-20 h-20 bg-primary-blue/5 rounded-full flex items-center justify-center mb-6 group-hover:bg-primary-blue group-hover:text-white transition-colors duration-500">
                      <Icon size={36} className="text-primary-blue group-hover:text-white transition-colors duration-500" />
                    </div>
                    
                    <h4 className="text-2xl font-bold text-neutral-darkNavy mb-3">{step.title}</h4>
                    <p className="text-base text-gray-500 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                  
                  {/* Connector for Mobile */}
                  {index < PROCESS_STEPS.length - 1 && (
                    <div className="md:hidden absolute bottom-0 left-1/2 w-1 h-8 bg-gray-200 transform translate-y-full -translate-x-1/2" />
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
